import { BrandFilter } from '@/components/brand-filter';
import { ProductCard } from '@/components/product-card';
import { EmptyState } from '@/components/ui';
import { useSuspenseQuery } from '@tanstack/react-query';
import { shopQuery } from '@/queries';
import { shopSubtitle } from '@/lib/shop-subtitle';

// AC-1.2 / plan §3: catalogue is server-rendered and revalidates every 5 minutes,
// with on-demand revalidation fired by the admin publish flow.

export default function ShopPage() {
  const { brands, catalogue } = useSuspenseQuery(shopQuery()).data;

  return (
    <div className="mx-auto max-w-[1180px] px-[30px] py-12">
      <header className="mb-8">
        <h1 className="text-[32px] font-extrabold tracking-[-0.03em] sm:text-[40px]">Shop</h1>
        {/* Three cases, and the zero one used to read "0 labels, one
            checkout". See src/lib/shop-subtitle.ts. R-140, R-382. */}
        <p className="mt-2 max-w-[52ch] text-[17px] text-muted">{shopSubtitle(brands)}</p>
      </header>

      <BrandFilter brands={brands} active={null} />

      {catalogue.length === 0 ? (
        <EmptyState
          title="Nothing published yet"
          body="Products appear here once they are published from the admin catalogue."
        />
      ) : (
        <div className="mt-8 grid grid-cols-2 gap-[26px] lg:grid-cols-4">
          {catalogue.map((item) => (
            <ProductCard key={item.id} item={item} />
          ))}
        </div>
      )}
    </div>
  );
}
